import { firstDefined } from '@avantia/client-and-server-utilities';
import { hasOwnProperty } from '@avantia/logging-and-errors';

import { logError } from '../../../clientLogging';
import { HpInputControlProps } from '../../../types/inputControlTypes';
import { FluentFormGroupWidget } from '../../widgets/fluentFormGroupWidget';
import { BasicDropDownListControl } from '../common/basicDropDownListControl';
import { createMouseEvent } from '../inputControl';
import { compileQuestion } from './utilities';

export function DropDownListControl({
  answers,
  answerSource,
  data,
  disabled,
  errors,
  id,
  name,
  onClick,
  productId,
  question,
  questionText,
  ui,
  value: answerValue
}: HpInputControlProps): JSX.Element {
  const value = answerValue as string;
  const errorText = errors[id];
  const hasError = !!errorText;
  const { lookup } = data;
  const isEditing = ui ? ui.isEditing : false;
  const classAnswer = `fluent-input ${isEditing ? 'fluent-hidden' : ''}`;
  const classEditor = `fluent-input ${isEditing ? '' : 'fluent-hidden'}`;
  const classError = hasError ? ' fluent-error' : '';

  const editControl = (
    <BasicDropDownListControl
      answers={answers}
      className={classEditor + classError}
      disabled={disabled}
      eventDetail={{ type: 'fluent-click', question }}
      id={id}
      lookup={lookup}
      name={name}
      onClick={onClick}
      productId={productId}
      sortItemsBy={undefined}
      textProperty="fluentText"
      ui={ui}
      value={value}
    />
  );

  const item = lookup[value];
  if (!item && value && !hasOwnProperty(lookup, value)) {
    logError(`There is no lookup for value "${value}" for question "${id}".`);
  }

  const answerText = item ? firstDefined(item.fluentText, item.text, value) : value;
  const control = compileQuestion({
    id,
    questionText,
    answerText: answerText || '',
    onClick: createMouseEvent(onClick, { type: 'fluent-toggle', question }),
    className: classAnswer,
    editControl
  });

  return (
    <FluentFormGroupWidget
      answerSource={answerSource}
      controlType="dropdown"
      error={errorText}
      id={id}
      question={control}
    />
  );
}
